import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgServerIconSolid = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 52.5,
	viewBox: "0 0 60 52.5",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M60,3.75v15c0,2.06-1.69,3.75-3.75,3.75H3.75c-2.06,0-3.75-1.69-3.75-3.75V3.75C0,1.69,1.69,0,3.75,0H56.25c2.06,0,3.75,1.69,3.75,3.75Zm0,30v15c0,2.06-1.69,3.75-3.75,3.75H3.75c-2.06,0-3.75-1.69-3.75-3.75v-15c0-2.06,1.69-3.75,3.75-3.75H56.25c2.06,0,3.75,1.69,3.75,3.75Zm-15.94-22.5c0-1.55-1.27-2.81-2.81-2.81s-2.81,1.26-2.81,2.81,1.26,2.81,2.81,2.81,2.81-1.27,2.81-2.81Zm0,30c0-1.55-1.26-2.81-2.81-2.81s-2.81,1.26-2.81,2.81,1.26,2.81,2.81,2.81,2.81-1.26,2.81-2.81Zm7.5-30c0-1.55-1.27-2.81-2.81-2.81s-2.81,1.26-2.81,2.81,1.26,2.81,2.81,2.81,2.81-1.27,2.81-2.81Zm0,30c0-1.55-1.26-2.81-2.81-2.81s-2.81,1.26-2.81,2.81,1.26,2.81,2.81,2.81,2.81-1.26,2.81-2.81Z" })]
});
const ForwardRef = forwardRef(SvgServerIconSolid);
export default ForwardRef;
